import { Modules } from "@/modules/module-list";
import { getMenu } from "../wp/getMenu";
import { GetStaticPropsContext } from "next";
import {
  CategoryType,
  FileType,
  MenuType,
  OptionsType,
} from "../types/baseTypes";
import { globalGetStaticPaths } from "../wp/globalGetStaticPaths";
import { globalGetPageData } from "../wp/globalGetPageData";
import { HeadMeta } from "../components/Header/Head";
import { getRelativePathFromLink, isValidWpSlug, validURL } from "../utils/url";
import { hasChildPages } from "../wp/hasChildren";
import {
  getFooterOptions,
  getHeadersOptions,
  getIconsOptions,
  getModuleOptions,
} from "../getData/getModuleOptions";
import {
  ModuleOptionsType,
  HeadersOptionsType,
  StartPageType,
  IconsType,
  popupOptionType,
} from "@/types/ModuleOptionsType";
import { filterObjectByArrayKeys } from "../utils/filterObjectByArrayKeys";
import { getThemeOptions } from "../wp/getOptions";
import {
  LabelsType,
  NewsLetterOptionType,
  OptionsEndCardsType,
  OptionsFactsheetsType,
  OptionsFooterType,
  OptionsGoogleMapType,
  OptionsHeaderType,
  OptionsSearchType,
  OptionsSecurityHeader,
  OptionsSeoSettingsType,
  OptionsSocialMediaType,
  popupType,
  TemplateRoutingSettings,
} from "@/types/OptionType";
import { Footer } from "../components/Footer/Footer";
import { Header } from "../components/Header/Header/Header";
import { Navbar, NavbarOptionType } from "../components/Navbar/Navbar";
import { getInsta } from "../wp/getInsta";
import { ParentsType } from "../wp/getParentPages";
import { SearchResult } from "../components/SearchResult/SearchResult";
import { GlobalContextProvider } from "@aleksundshantu/aunds-utils-react/contexts";
import MotionPopUp from "../components/PopUp/PopUp";

import {
  getIndexedPostSliderData,
  IndexedPostSlidereData,
} from "../getData/getIndexedPostSliderData";
import { useRef } from "react";
import type { Module as ModuleType } from "../wp/types/acf-module-types";
import autoLinkGlossarTerms from "@/utils/glossary/glossaryLinking";
import GlossarTooltip from "@/components/GlossarTooltip/GlossarTooltip.tsx";
import { EphemeralStore, EphemeralStoreKey } from "@/utils/ephemeralStore.ts";

import { useAppContext } from "@/context/AppContext";
import { Post, PostTreeItem } from "@/wp/types/client";
import {
  getIndexedFormsData,
  IndexedFormsData,
} from "@/getData/getIndexedFormsData";
import {
  BreakpointsOptionsType,
  getBreakpointsFromOptions,
} from "@/getData/getBreakpoints";
import {
  getTeaserSliderData,
  TeaserSliderDataType,
} from "@/getData/getTeaserSliderData";
import {
  getTextMediaDiagramData,
  getMediaDiagramData,
  TextMediaDiagramDataType,
} from "@/getData/getTextMediaDiagramData";
import {
  getFullWidthSliderData,
  MultipleFullWidthSliderDataType,
} from "@/getData/getFullWidthSliderData";
import {
  getQuotesSliderData,
  QuotesSliderDataType,
} from "@/getData/getQuotesSliderData";
import {
  getLogoSliderData,
  LogoSliderDataType,
} from "@/getData/getLogoSliderData";
import {
  getIndexedEventSliderData,
  IndexedEventSliderData,
} from "@/getData/getIndexedEventSliderData";
import { Modal } from "@/modules/Insta/Modal/Modal";
import { getTemplateRouting } from "@/wp/getTemplateRouting";
import {
  getIndexedNewsletterData,
  IndexedNewsletterData,
} from "@/getData/getIndexedNewsletterData";
import {
  getIndexedContactData,
  IndexedContactData,
} from "@/getData/getContactTeamData";
import {
  getPostGridCatData,
  getBlogPostCategories,
  PostGridCategories,
  CategoryOverviewPages,
} from "../getData/getIndexedPostGridData";
import { getCategoryOverviewSettings } from "@/getData/getCategoryOverviewSettings";
import {
  getPostForType,
  getCategoryBySlug,
  getPostsByAuthor,
  getPageById,
} from "@/wp/getPosts";
import {
  getIndexedAccordionData,
  IndexedAccordionData,
} from "@/getData/getIndexedAccordionData";
import { getMetalCsvFile } from "@/getData/getMetalCsvFile";
import {
  getIndexedLinkListData,
  IndexedLinkListData,
} from "@/getData/getIndexedLinkListData";
import {
  getIndexedMaterialOverviewData,
  IndexedMaterialOverviewData,
} from "@/getData/getIndexedMaterialOverviewData";
import { TeamPostList } from "@/components/Header/TeamHeader/TeamPostList/TeamPostList.tsx";
import { getSitemapData, SitemapGroup } from "@/getData/getSitemapData.ts";
import { getRelatedMetals } from "@/getData/getRelatedMetals";
import { getRelatedJobIds } from "@/getData/getRelatedJobIds";
import { getRelatedBlogPosts } from "@/getData/getRelatedBlogPosts";
import { PostFootModule } from "@/modules/PostFootModule/PostFootModule";
import { TeaserSliderElementType } from "@/components/TeaserCard/TeaserCard";
import { FormData } from "@/getData/getIndexedFormsData";
import {
  BilletoEventOverviewType,
  fetchAllBillettoEvents,
} from "@/getData/fetchBillettoData";
import { rewriteOnlyAcfLinkUrlFields } from "@/hooks/translateURLIfNeeded.ts";
import { getDataArrayGeneric } from "@/getData/getData";
import { getStartPage } from "../wp/getStartpage";
import { getTranslatedPageDataForLocale } from "../utils/wpmlUtils";
import {
  NotFoundPage,
  NotFoundPageProps,
} from "@/components/NotFoundPage/NotFoundPage";

type Module = ModuleType["module"][number];

export interface DynamicPageProps {
  locale: string;
  pageData: Post;
  legalMenu: MenuType;
  mainMenu: MenuType;
  // TODO: Never pass full options object to page props
  // options: OptionsType;
  categories: CategoryType[];
  headerOptions: HeadersOptionsType;
  moduleOptions: ModuleOptionsType;
  socialMedia: OptionsSocialMediaType;
  footerOptions: OptionsFooterType;
  breakpoints: BreakpointsOptionsType | null;
  navbarOption: NavbarOptionType;
  labels: LabelsType;
  footerMenu: MenuType;
  startPageOptions: StartPageType;
  insta: string;
  parents: ParentsType;
  allTeaserData: TeaserSliderDataType[];
  textMediaDiagramData: TextMediaDiagramDataType[];
  mediaDiagramData: TextMediaDiagramDataType[];
  allFullWidthSliderData: MultipleFullWidthSliderDataType[];
  newsletterOptions: NewsLetterOptionType;
  icons: IconsType;
  searchOptions: OptionsSearchType;
  allQuotesData: QuotesSliderDataType[];
  allLogosData: LogoSliderDataType[];
  popupOptions: popupOptionType;
  popupData: popupType;
  endCards: OptionsEndCardsType;
  indexedEventSliderData: IndexedEventSliderData;
  indexedPostSliderData: IndexedPostSlidereData;
  indexedNewsletterData: IndexedNewsletterData;
  headerThemeOptions: OptionsHeaderType;
  securityHeaderOptions: OptionsSecurityHeader;
  googleMapThemeOptions: OptionsGoogleMapType;
  seoSettingsOptions: OptionsSeoSettingsType;
  indexedFormsData: IndexedFormsData;
  formBulderOptions: OptionsType["acf"]["form_builder"];
  routing: TemplateRoutingSettings;
  indexedContactData: IndexedContactData;
  PostGridCategories: PostGridCategories;
  indexedAccordionData: IndexedAccordionData;
  indexedLinkListData: IndexedLinkListData;
  indexedMaterialOverviewData: IndexedMaterialOverviewData;
  csvFile: FileType;
  IS_NOBLE_ELEMENTS: boolean;
  teamPosts: Post<"blog">[];
  sitemapData: SitemapGroup[] | null;
  relatedMetals: TeaserSliderElementType[];
  relatedJobs: number[];
  relatedBlogPostIds?: number[];
  blogFormData?: FormData;
  blogCategories: CategoryOverviewPages[];
  billettoEventsData: BilletoEventOverviewType[] | null;
  factsheets: OptionsFactsheetsType;
}

type DynamicPageComponentProps =
  | (DynamicPageProps & { isNotFound?: false })
  | (NotFoundPageProps & { isNotFound: true });

export default function DynamicPage(props: DynamicPageComponentProps) {
  // Hooks must run unconditionally on every render (rules-of-hooks), so
  // they're called here, above the isNotFound branch below.
  const popupRef = useRef<HTMLDivElement>(null);
  const { instagramModal } = useAppContext();

  if (props.isNotFound) {
    return <NotFoundPage {...props} />;
  }

  const {
    // TODO: Never pass full options object to page props
    locale,
    pageData,
    headerOptions,
    moduleOptions,
    socialMedia,
    footerOptions,
    breakpoints,
    mainMenu,
    navbarOption,
    labels,
    footerMenu,
    legalMenu,
    startPageOptions,
    insta,
    parents,
    allTeaserData,
    textMediaDiagramData,
    mediaDiagramData,
    allFullWidthSliderData,
    allQuotesData,
    newsletterOptions,
    icons,
    searchOptions,
    allLogosData,
    popupOptions,
    popupData,
    endCards,
    indexedEventSliderData,
    indexedPostSliderData,
    headerThemeOptions,
    securityHeaderOptions,
    googleMapThemeOptions,
    indexedFormsData,
    indexedNewsletterData,
    formBulderOptions,
    seoSettingsOptions,
    routing,
    indexedContactData,
    PostGridCategories,
    indexedAccordionData,
    indexedLinkListData,
    indexedMaterialOverviewData,
    csvFile,
    teamPosts,
    sitemapData,
    relatedMetals,
    relatedJobs,
    relatedBlogPostIds,
    IS_NOBLE_ELEMENTS,
    blogFormData,
    blogCategories,
    billettoEventsData,
    factsheets,
  } = props;

  const bgColorSearchResults =
    "header_seite" in pageData.acf
      ? pageData?.acf?.header_seite?.breadcrumb_bg_color
      : undefined;
  const mainstartAriaLabel = labels?.find(
    (label) => label.key === "aria_label_mainstart",
  );
  const mainstartLabel = labels?.find((label) => label.key === "skip_nav");

  const isBigParagraph =
    "header_seite" in pageData.acf
      ? pageData.acf?.header_seite?.big_paragraph
      : false;

  return (
    <GlobalContextProvider iconsRaw={icons} labelsRaw={labels}>
      <HeadMeta
        post={pageData}
        securityHeaderOptions={securityHeaderOptions}
        seoSettingsOptions={seoSettingsOptions}
        routing={routing}
      />
      <div id="pagestart" tabIndex={-1} />
      {/* eslint-disable-next-line react/forbid-elements */}
      <a
        className="skipnav"
        href="#maincontent"
        {...(mainstartAriaLabel && {
          "aria-label": mainstartAriaLabel.value,
        })}
      >
        {mainstartLabel ? mainstartLabel.value : "Navigation überspringen"}
      </a>
      <Navbar
        searchPageSlug={searchOptions?.search_page_link || ""}
        menu={mainMenu}
        socialMedia={socialMedia.platforms}
        navbarOption={navbarOption}
        pageData={pageData}
        isHome={"header_startseite" in pageData.acf}
        isPage={
          "header_seite" in pageData.acf ||
          "header_post" in pageData.acf ||
          "header_metal" in pageData.acf
        }
        isTextHeader={
          ("header_seite" in pageData.acf &&
            pageData.acf.header_seite.type === "textheader") ||
          ("header_post" in pageData.acf &&
            pageData.acf.header_post.type === "textheader")
        }
        isNobleElements={IS_NOBLE_ELEMENTS}
      />

      {pageData && (
        <>
          <div id="maincontent" />
          <main id={`main-tag`}>
            <Header
              locale={locale}
              startPageOptions={startPageOptions}
              post={pageData}
              headerOptions={headerOptions}
              parents={parents}
              options={headerThemeOptions}
              blogCategories={blogCategories}
              isNobleElements={IS_NOBLE_ELEMENTS}
              factsheets={factsheets}
            />

            {pageData.acf?.module &&
              (pageData.acf.module as Array<Module>).map((module, index) => {
                const teaserSliderData = allTeaserData.find(
                  (d) => d.index === index,
                );
                const fullWidthSliderData = allFullWidthSliderData.find(
                  (d) => d.index === index,
                )?.data;
                const quotesSliderData = allQuotesData.find(
                  (d) => d.index === index,
                );

                const logoElements = allLogosData.find(
                  (d) => d.index === index,
                );

                return (
                  <Modules
                    index={index}
                    key={`${pageData.slug}-${module.acf_fc_layout}-${index}`}
                    module={module}
                    moduleOptions={moduleOptions}
                    breakpoints={breakpoints}
                    insta={insta}
                    socialMedia={socialMedia}
                    endCards={endCards}
                    teaserSliderData={
                      teaserSliderData ? teaserSliderData.data : []
                    }
                    quotesSliderData={
                      quotesSliderData ? quotesSliderData.data : []
                    }
                    fullWidthSliderData={fullWidthSliderData}
                    newsletterOptions={newsletterOptions}
                    logoElements={logoElements ? logoElements.data : []}
                    indexedEventSliderData={indexedEventSliderData}
                    indexedPostSliderData={indexedPostSliderData}
                    indexedNewsletterData={indexedNewsletterData}
                    isBigParagraph={isBigParagraph}
                    fallbackImages={headerThemeOptions.fallback_images}
                    headerOptions={headerOptions}
                    googleMapThemeOptions={googleMapThemeOptions}
                    type={pageData.type}
                    pageId={pageData.id}
                    indexedFormsData={indexedFormsData}
                    formBulderOptions={formBulderOptions}
                    indexedContactData={indexedContactData}
                    PostGridCategories={PostGridCategories}
                    indexedAccordionData={indexedAccordionData}
                    indexedLinkListData={indexedLinkListData}
                    indexedMaterialOverviewData={indexedMaterialOverviewData}
                    metalCsvFile={csvFile}
                    textMediaDiagramData={textMediaDiagramData}
                    mediaDiagramData={mediaDiagramData}
                    sitemapData={sitemapData}
                    isNobleElements={IS_NOBLE_ELEMENTS}
                    billettoEventsData={billettoEventsData}
                    factsheets={factsheets}
                  />
                );
              })}
            {pageData.type !== "page" && pageData.type !== "noble_elements" && (
              <PostFootModule
                pageData={pageData}
                labels={labels}
                relatedMetals={relatedMetals}
                relatedJobs={relatedJobs}
                moduleOptions={moduleOptions}
                csvFile={csvFile}
                isNobleElements={IS_NOBLE_ELEMENTS}
                blogFormData={blogFormData}
                relatedBlogPostIds={relatedBlogPostIds}
              />
            )}
            {pageData.type == "team" && <TeamPostList posts={teamPosts} />}
            <SearchResult
              searchOptions={searchOptions}
              bgColor={bgColorSearchResults || ""}
            />
            <MotionPopUp
              popupOptions={popupOptions}
              popupData={popupData}
              ref={popupRef}
            />
            {instagramModal && <Modal />}
          </main>
        </>
      )}
      <Footer
        autoShowConsentManagement={
          "header_seite" in pageData.acf
            ? pageData.acf?.header_seite?.show_consent_management
            : true
        }
        footerOptions={footerOptions}
        socialMedia={socialMedia}
        footerMenu={footerMenu}
        legalMenu={legalMenu}
      />
      <GlossarTooltip key={pageData.slug} />
    </GlobalContextProvider>
  );
}

export async function getStaticPaths({}) {
  const allPaths = await globalGetStaticPaths();
  return {
    paths: allPaths,
    fallback: "blocking",
  };
}

export const isEmptyParentPage = async ({
  pageData,
  locale,
  defaultLocale,
}: {
  pageData: Post;
  locale: string;
  defaultLocale: string;
}): Promise<boolean> => {
  if (!pageData?.acf?.module && pageData.type === "page") {
    const hasChildren = await hasChildPages({
      id: pageData.id,
      locale,
      defaultLocale,
    });
    if (hasChildren) {
      return true;
    }
    return false;
  }
  return false;
};

export async function getStaticProps(context: GetStaticPropsContext) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any --- FIXME: disabled temporarily on migrate to TS.
    const { dynamicRoute }: any = context.params;
    const locale = context.locale || "de";
    const defaultLocale = context.defaultLocale || "de";

    // Middleware unconditionally prefixes every request on the
    // noble-elements host with "/noble-elements", even for paths that
    // don't resolve to a real WP page — so this is reliable brand
    // detection even before (or without) a resolved pageData. Unlike
    // pages/404.tsx (which has no request info at all in getStaticProps),
    // this route re-runs per-request for unseen paths (fallback: "blocking"),
    // so it can render a correctly-branded not-found page instead of
    // delegating to the single, brand-blind pages/404.tsx.
    const isNobleElementsFromPath =
      Array.isArray(dynamicRoute) && dynamicRoute[0] === "noble-elements";

    // jscpd:ignore-start -- intentionally mirrors pages/404.tsx's data-fetching for the not-found case
    const renderNotFound = async (isNobleElementsOverride?: boolean) => {
      const isNobleElements =
        isNobleElementsOverride ?? isNobleElementsFromPath;

      let notFoundStartpage: Post | null = await getStartPage();
      if (locale !== defaultLocale) {
        const wpmlData = getTranslatedPageDataForLocale(
          notFoundStartpage,
          locale,
        );
        if (wpmlData) {
          notFoundStartpage = await getPageById({ id: wpmlData.id });
        }
      }

      const notFoundPost = {
        ...notFoundStartpage,
        id: 0, // No real WP id matches this, so no navbar menu item is ever marked as current
        type: "page",
        title: { rendered: "404" },
        link: "", // No canonical link for 404 pages
        acf: { header_seite: {} },
      };

      const fetchNotFoundOptions = getThemeOptions({ locale, defaultLocale });
      const fetchNotFoundIconsAllOptions = getIconsOptions();
      const fetchNotFoundMainMenu = getMenu({
        slug: (isNobleElements ? "main-noble-elements" : "main") + "-" + locale,
      });
      const fetchNotFoundFooterMenu = getMenu({
        slug:
          (isNobleElements ? "footer-noble-elements" : "footer") + "-" + locale,
      });
      const fetchNotFoundLegalMenu = getMenu({
        slug:
          (isNobleElements ? "legal-noble-elements" : "legal") + "-" + locale,
      });
      const fetchNotFoundModuleAllOptions = getModuleOptions();
      const fetchNotFoundFooterAllOptions = getFooterOptions();

      const [
        notFoundThemeOptions,
        notFoundIconsAllOptions,
        notFoundMainMenu,
        notFoundFooterMenu,
        notFoundLegalMenu,
        notFoundModuleAllOptions,
        notFoundFooterAllOptions,
      ] = await Promise.all([
        fetchNotFoundOptions,
        fetchNotFoundIconsAllOptions,
        fetchNotFoundMainMenu,
        fetchNotFoundFooterMenu,
        fetchNotFoundLegalMenu,
        fetchNotFoundModuleAllOptions,
        fetchNotFoundFooterAllOptions,
      ]);

      const notFoundFooterOptions = isNobleElements
        ? {
            ...notFoundThemeOptions.footer_elements,
            footer_structure: notFoundThemeOptions.footer.footer_structure,
            ...notFoundFooterAllOptions,
          }
        : { ...notFoundThemeOptions.footer, ...notFoundFooterAllOptions };

      const notFoundNavbarOption = {
        themeOption: notFoundThemeOptions.header,
        moduleOption: notFoundModuleAllOptions?.navigation,
        promoBox: isNobleElements
          ? notFoundThemeOptions?.promobox?.noble_elements || null
          : notFoundThemeOptions?.promobox?.noble_bc || null,
      };

      const notFoundSeoSettingsOptions: OptionsSeoSettingsType = {
        ...((isNobleElements
          ? notFoundThemeOptions?.seo_settings_elements
          : notFoundThemeOptions?.seo_settings) || {}),
        disable_indexing: true, // ← Noindex for 404 pages
      };

      return {
        props: {
          isNotFound: true as const,
          options: notFoundThemeOptions.viernullvier,
          post: notFoundPost,
          labels: notFoundThemeOptions.labels || [],
          icons: notFoundIconsAllOptions,
          securityHeaderOptions: notFoundThemeOptions.security_header,
          seoSettingsOptions: notFoundSeoSettingsOptions,
          mainMenu: notFoundMainMenu,
          footerMenu: notFoundFooterMenu,
          legalMenu: notFoundLegalMenu,
          socialMedia: notFoundThemeOptions.social_media,
          footerOptions: notFoundFooterOptions,
          navbarOption: notFoundNavbarOption,
          searchOptions: notFoundThemeOptions.search,
          isNobleElements,
        },
        revalidate: parseInt(process.env.REVALIDATE_AFTER || "120"),
      };
    };
    // jscpd:ignore-end

    const slug = dynamicRoute?.[dynamicRoute.length - 1];
    if (slug !== undefined && !isValidWpSlug(slug)) {
      return renderNotFound();
    }
    if (context.preview && typeof context.previewData !== "string") {
      return renderNotFound();
    }

    const privatePageData = EphemeralStore.getEntry(
      context.previewData as EphemeralStoreKey,
    );
    let pageData =
      context.preview && !privatePageData.isNone
        ? privatePageData.value
        : await globalGetPageData({ dynamicRoute, locale, defaultLocale });

    let constructedPagePath, pagePath;

    if (dynamicRoute) {
      pagePath = getRelativePathFromLink(pageData?.link || "");
      constructedPagePath =
        pageData?.type === "noble_elements" ||
        (pageData?.link &&
          validURL(pageData.link) &&
          new URL(pageData.link).hostname.includes("elements"))
          ? `/${
              locale === defaultLocale ? "" : locale + "/"
            }${dynamicRoute.join("/")}/`.replace(
              pagePath === "/" || pagePath === `/${locale}/`
                ? `/noble-elements/${process.env.NEXT_PUBLIC_STARTPAGE_SLUG_ELEMENTS}`
                : "/noble-elements",
              "",
            )
          : `/${
              locale === defaultLocale ? "" : locale + "/"
            }${dynamicRoute.join("/")}/`;
    }

    let cachedRouting: TemplateRoutingSettings | null = null;

    if (!pageData || pagePath !== constructedPagePath) {
      const [categoryOverviewSettings, routing] = await Promise.all([
        getCategoryOverviewSettings(),
        getTemplateRouting(),
      ]);
      cachedRouting = routing;

      let specialRouteFound = false;
      const enableCategoryPath =
        categoryOverviewSettings?.acf?.aunds_enable_category_path_segment;

      if (enableCategoryPath && routing && dynamicRoute?.length === 3) {
        const blogRouting = routing["blog"];
        const blogSlug =
          blogRouting?.slugs?.[locale] || blogRouting?.slugs?.["default"];
        if (dynamicRoute[0] === blogSlug) {
          const postSlug = dynamicRoute[2];

          const [potentialPageData] = await Promise.all([
            getPostForType({
              slug: postSlug,
              type: "blog",
              locale,
              defaultLocale,
            }).then((res) => res?.[0]),
            getCategoryBySlug({
              slug: dynamicRoute[1],
              locale,
              defaultLocale,
            }),
          ]);

          if (potentialPageData) {
            pageData = potentialPageData;
            specialRouteFound = true;

            // Construct custom parents for breadcrumbs
            /*     const startSlugTitle =
              blogSlug.charAt(0).toUpperCase() + blogSlug.slice(1);
            if (categoryData) {
              parents.push(
                {
                  title: startSlugTitle,
                  url: null, // No link for start slug
                  isEmptyParentPage: false,
                },
                {
                  title: categoryData.name,
                  url: `/${
                    locale === defaultLocale ? "" : locale + "/"
                  }${blogSlug}/${categoryData.slug}`,
                  isEmptyParentPage: false,
                },
              );
            }*/
          }
        }
      }

      if (!specialRouteFound) {
        return renderNotFound();
      }
    }

    if (!pageData) {
      return renderNotFound();
    }

    //! Noble Elements check
    const IS_NOBLE_ELEMENTS = Boolean(
      pageData.type === "noble_elements" ||
      (pageData.link &&
        validURL(pageData.link) &&
        new URL(pageData.link).hostname.includes("elements")),
    );

    // 1. Finde den dynamischen Header-Key (z.B. header_videos, header_activities, etc.)
    const dynamicHeaderKeySinglePage = Object.keys(pageData.acf || {}).find(
      (key) => key.startsWith("header_"),
    ) as keyof typeof pageData.acf | undefined;

    if (dynamicHeaderKeySinglePage) {
      const headerData = pageData.acf[dynamicHeaderKeySinglePage];
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const hasSingleView = (headerData as any)?.has_single_page ?? true;

      if (!hasSingleView) {
        return renderNotFound(IS_NOBLE_ELEMENTS);
      }
    }

    // Return 404 for empty parent pages
    if (await isEmptyParentPage({ pageData, locale, defaultLocale })) {
      return renderNotFound(IS_NOBLE_ELEMENTS);
    }
    const fetchRouting = cachedRouting
      ? Promise.resolve(cachedRouting)
      : getTemplateRouting();
    const fetchOptions = getThemeOptions({ locale, defaultLocale });
    /*const fetchCategories = getCategories({
      category: "categories",
      locale: context.locale,
      defaultLocale: context.defaultLocale,
    });*/

    if (locale !== defaultLocale) {
      pageData = await rewriteOnlyAcfLinkUrlFields(pageData, {
        currentLocale: locale,
        pageLink: pageData?.link,
      });
    }

    const fetchLegalMenu = getMenu({
      slug:
        (IS_NOBLE_ELEMENTS ? "legal-noble-elements" : "legal") +
        (context.locale ? "-" + context.locale : ""),
    });
    const fetchFooterMenu = getMenu({
      slug:
        (IS_NOBLE_ELEMENTS ? "footer-noble-elements" : "footer") +
        (context.locale ? "-" + context.locale : ""),
    });
    const fetchMainMenu = getMenu({
      slug:
        (IS_NOBLE_ELEMENTS ? "main-noble-elements" : "main") +
        (context.locale ? "-" + context.locale : ""),
    });

    // Do not fetch all module options here. Fetch only the ones needed for the page by using _fields parameter
    const fetchModuleAllOptions = getModuleOptions();
    const fetchHeadersAllOptions = getHeadersOptions();
    const fetchFooterAllOptions = getFooterOptions();
    const fetchIconsAllOptions = getIconsOptions();
    const iconsAllOptions = await fetchIconsAllOptions;
    const fetchFullWidthSliderData = getFullWidthSliderData({
      pageData,
      locale,
      defaultLocale,
    });
    const fetchTextMediaDiagramData = getTextMediaDiagramData(
      pageData,
      locale,
      defaultLocale,
    );
    const fetchMediaDiagramData = getMediaDiagramData(
      pageData,
      locale,
      defaultLocale,
    );
    const allQuotesData = await getQuotesSliderData(
      pageData,
      locale,
      defaultLocale,
      iconsAllOptions,
    );

    const fetchLogosData = getLogoSliderData(pageData, locale, defaultLocale);
    const fetchContactData = getIndexedContactData({
      pageData,
      locale,
      defaultLocale,
    });

    const parents: ParentsType = [];

    const parentObject = (parent: PostTreeItem) => ({
      title: parent.breadcrumb_title || parent.title,
      url: parent.link,
      isEmptyParentPage: parent.is_empty || false,
    });

    const isNotRootUrl = (url: string) => {
      try {
        return new URL(url).pathname !== "/";
      } catch {
        return true;
      }
    };

    if (pageData.type === "page") {
      pageData.post_tree?.parents
        ?.filter((parent: PostTreeItem) => isNotRootUrl(parent.link))
        .forEach((parent: PostTreeItem) => {
          parents.push(parentObject(parent));
        });
    } else {
      pageData.post_tree?.post_type_root_parents
        ?.filter((child: PostTreeItem) => isNotRootUrl(child.link))
        .forEach((child: PostTreeItem) => {
          parents.push(parentObject(child));
        });
      if (
        pageData.post_tree?.post_type_root &&
        isNotRootUrl(pageData.post_tree.post_type_root.link)
      ) {
        const parent = pageData.post_tree.post_type_root;
        parents.push(parentObject(parent));
      }
    }

    // 1. Find the key, but tell TS it's a valid key of the acf object
    const dynamicHeaderKey = Object.keys(pageData.acf).find((key) =>
      key.startsWith("header_"),
    ) as keyof typeof pageData.acf | undefined;

    // 2. Now TS knows that dynamicHeaderKey (if it exists) is a safe index
    const headerData = dynamicHeaderKey ? pageData.acf[dynamicHeaderKey] : null;

    parents.push({
      title:
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (headerData as any)?.seo_settings?.breadcrumb_title ||
        pageData.title.rendered,
      url: pageData.link,
      isEmptyParentPage: false,
    });

    /* const fetchParents = getParentPages({
      nextParent: pageData.parent,
      locale,
      defaultLocale,
    });*/

    const moduleAllOptions = await fetchModuleAllOptions; //first fetch all module options outside the Promise.all to allow other fetches inside Promise.all to use module options
    const themeOptions = await fetchOptions; // first fetch theme options outside the Promise.all to allow other fetches inside Promise.all to use theme options
    const fetchTeaserData = getTeaserSliderData(
      pageData,
      themeOptions.factsheets,
      locale,
      defaultLocale,
    );
    const fetchIndexedEventSliderData = getIndexedEventSliderData({
      pageData,
      eventsSliderOptions: moduleAllOptions?.events_slider,
      locale,
      defaultLocale,
    });
    const fetchIndexedPostSliderData = getIndexedPostSliderData({
      pageData,
      locale,
      defaultLocale,
      fallback_options:
        moduleAllOptions?.slider?.slider_options.fallback_options,
      fallback_image: themeOptions?.header.fallback_images.header_posts,
    });

    const fetchIndexedFormsData = getIndexedFormsData({
      pageData,
      locale,
      defaultLocale,
    });
    const fetchIndexedNewsletterData = getIndexedNewsletterData({
      pageData,
      newsletterOptions: themeOptions.newsletter,
      locale,
      defaultLocale,
    });

    const fetchPostGridCategories = getPostGridCatData({
      pageData,
      locale,
      defaultLocale,
    });

    const fetchIndexedAccordionData = getIndexedAccordionData({
      pageData,
      locale,
      defaultLocale,
    });

    const fetchIndexedLinkListData = getIndexedLinkListData({
      pageData,
      locale,
      defaultLocale,
      labels: themeOptions.labels || [],
    });

    const fetchIndexedMaterialOverviewData = getIndexedMaterialOverviewData({
      pageData,
      locale,
      defaultLocale,
    });

    const [
      legalMenu,
      mainMenu,
      headersAllOptions,
      footerMenu,
      footerAllOptions,

      allTeaserData,
      allFullWidthSliderData,

      allLogosData,
      indexedEventSliderData,
      indexedPostSliderData,
      indexedFormsData,
      indexedNewsletterData,
      routing,
      indexedContactData,
      postGridCategories,
      indexedAccordionData,
      indexedLinkListData,
      textMediaDiagramData,
      mediaDiagramData,
      indexedMaterialOverviewData,
    ] = await Promise.all([
      fetchLegalMenu,
      fetchMainMenu,
      fetchHeadersAllOptions,
      fetchFooterMenu,
      fetchFooterAllOptions,

      fetchTeaserData,
      fetchFullWidthSliderData,

      fetchLogosData,
      fetchIndexedEventSliderData,
      fetchIndexedPostSliderData,
      fetchIndexedFormsData,
      fetchIndexedNewsletterData,
      fetchRouting,
      fetchContactData,
      fetchPostGridCategories,
      fetchIndexedAccordionData,
      fetchIndexedLinkListData,
      fetchTextMediaDiagramData,
      fetchMediaDiagramData,
      fetchIndexedMaterialOverviewData,
    ]);

    let billettoEventsData: BilletoEventOverviewType[] | null = null;
    if (
      Array.isArray(dynamicRoute) &&
      dynamicRoute.length === 1 &&
      dynamicRoute[0] === "events"
    ) {
      const billettoResponse = await fetchAllBillettoEvents({
        startsAfter: new Date(),
        state: "published",
        expand: "data.location",
      });
      billettoEventsData = billettoResponse?.data ?? null;
    }

    /*
    //check if we have a "parent"/overview page for the post type
    const postTypePath = customPostTypesPathMapping.find(
      (t) => t.postType === pageData?.type && t.language === locale,
    )?.path;
    if (postTypePath) {
      const postTypeOverviewPage = (
        await getPostForType({
          slug: postTypePath,
          type: "pages",
          defaultLocale,
          locale,
          fields: "acf,link,title",
        })
      )?.[0];
      if (postTypeOverviewPage && "header_seite" in postTypeOverviewPage.acf) {
        const headerTitle = postTypeOverviewPage?.acf?.header_seite?.title;
        parents.unshift({
          isEmptyParentPage: false,
          title: headerTitle ?? "",
          url: postTypeOverviewPage?.link,
        });
      }
    }
  */
    // Get a set of all layouts used on the current page
    const uniqueModuleKeys = new Set(
      (pageData.acf?.module as Array<Module>)?.map?.(
        (module) => module?.acf_fc_layout,
      ),
    );

    let breakpoints = null;
    if (
      uniqueModuleKeys.has("textmedia") ||
      uniqueModuleKeys.has("quotes_banner")
    ) {
      breakpoints = await getBreakpointsFromOptions();
    }

    let sitemapData: SitemapGroup[] | null = null;
    if (uniqueModuleKeys.has("sitemap") && pageData.acf?.module) {
      sitemapData = await getSitemapData({
        isNobleElements: pageData.type === "noble_elements",
        locale,
        defaultLocale,
        labels: themeOptions.labels,
      });
    }

    let uniqueModuleKeysArray: string[] = Array.from(uniqueModuleKeys);

    if (pageData.type === "metals") {
      uniqueModuleKeysArray.push("teaser_slider");
    }

    if (pageData.type === "jobs") {
      uniqueModuleKeysArray.push("link_list");
    }

    if (pageData.type === "blog") {
      uniqueModuleKeysArray.push("link_list");
      uniqueModuleKeysArray.push("formbuilder");
    }

    // it uniqueModuleKeysArray has newsletter thre replace it with newsletter_options
    if (uniqueModuleKeysArray.includes("newsletter")) {
      uniqueModuleKeysArray = uniqueModuleKeysArray.map((key) =>
        key === "newsletter" ? "newsletter_options" : key,
      );
    }

    // linklist uses icon_grid options
    if (uniqueModuleKeysArray.includes("linklist")) {
      uniqueModuleKeysArray = uniqueModuleKeysArray.map((key) =>
        key === "linklist" ? "link_list" : key,
      );
    }

    let moduleOptionsForCurrentPage;

    if (moduleAllOptions) {
      // Get all module options for the current page --- DO NOT pass all module options to the page
      moduleOptionsForCurrentPage = filterObjectByArrayKeys(
        moduleAllOptions,
        uniqueModuleKeysArray,
      );
    }

    const glossarHeaderOptions = headersAllOptions?.header_glossar;
    if (glossarHeaderOptions) {
      if (glossarHeaderOptions.posttypes_to_link.length > 0) {
        if (glossarHeaderOptions.posttypes_to_link.includes(pageData.type)) {
          pageData = await autoLinkGlossarTerms({
            pageData,
            locale,
            defaultLocale,
            showTooltip: glossarHeaderOptions.show_tooltip,
          });
        }
      } else {
        pageData = await autoLinkGlossarTerms({
          pageData,
          locale,
          defaultLocale,
          showTooltip: glossarHeaderOptions.show_tooltip,
        });
      }
    }

    const needsCsvFile =
      pageData.type === "metals" ||
      uniqueModuleKeys.has("media") ||
      uniqueModuleKeys.has("textmedia") ||
      uniqueModuleKeys.has("teaser_slider") ||
      uniqueModuleKeys.has("metal_grid");

    const fetchBlogFormData = (formId: string) =>
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      getDataArrayGeneric<any>(`/forms/${formId}`, locale, defaultLocale)
        .then((res) => res.pageData)
        .then((formRes: { acf?: Record<string, unknown> } | null) =>
          formRes?.acf
            ? {
                formHeader: JSON.parse(JSON.stringify(formRes.acf)),
                formId: 43100,
              }
            : null,
        )
        .catch(() => null);

    const [
      csvFile,
      insta,
      teamPosts,
      relatedMetals,
      relatedJobs,
      blogCategories,
      relatedBlogPostIds,
      blogFormData,
    ] = await Promise.all([
      needsCsvFile ? getMetalCsvFile() : Promise.resolve(null),

      uniqueModuleKeys.has("instagram")
        ? getInsta(themeOptions.social_media.instagram_feed_id || "1")
        : Promise.resolve(null),

      pageData.type === "team"
        ? getPostsByAuthor({
            authorId: pageData.id,
            locale,
            defaultLocale,
          }).then((r) => r ?? [])
        : Promise.resolve([]),

      pageData.type === "metals"
        ? getRelatedMetals(
            pageData.id,
            pageData.location_category,
            locale,
            defaultLocale,
          )
        : Promise.resolve([]),

      pageData.type === "jobs"
        ? getRelatedJobIds(pageData.location_category, locale, defaultLocale)
        : Promise.resolve([]),

      pageData.type === "blog"
        ? getBlogPostCategories({
            categoryIds: pageData.categories ?? [],
            locale,
            defaultLocale,
          })
        : Promise.resolve([]),

      pageData.type === "blog"
        ? getRelatedBlogPosts(
            pageData.id,
            pageData.date,
            pageData.categories,
            pageData.location_category,
            locale,
            defaultLocale,
          )
        : Promise.resolve([]),

      pageData.type === "blog"
        ? fetchBlogFormData(locale === "en" ? "45397" : "43094")
        : Promise.resolve(null),
    ]);

    const shouldProvideStartPageOptions = !dynamicRoute || IS_NOBLE_ELEMENTS;
    const popupOptions = moduleAllOptions?.popup;

    return {
      props: {
        locale,
        pageData,
        legalMenu,
        footerMenu,
        mainMenu,
        headerOptions: headersAllOptions,
        moduleOptions: moduleOptionsForCurrentPage,
        socialMedia: themeOptions.social_media,
        footerOptions: IS_NOBLE_ELEMENTS
          ? {
              ...themeOptions.footer_elements,
              footer_structure: themeOptions.footer.footer_structure,
              ...footerAllOptions,
            }
          : { ...themeOptions.footer, ...footerAllOptions },
        endCards: themeOptions.end_cards,
        breakpoints,
        navbarOption: {
          themeOption: themeOptions.header,
          moduleOption: moduleAllOptions?.navigation,
          promoBox: IS_NOBLE_ELEMENTS
            ? themeOptions?.promobox?.noble_elements || null
            : themeOptions?.promobox?.noble_bc || null,
        },
        labels: themeOptions.labels || [],
        icons: iconsAllOptions,
        startPageOptions: shouldProvideStartPageOptions
          ? (moduleAllOptions?.startpage ?? null)
          : null,
        insta,
        parents,
        allTeaserData,
        textMediaDiagramData,
        mediaDiagramData,
        allFullWidthSliderData,
        allQuotesData,
        newsletterOptions: themeOptions.newsletter,
        searchOptions: themeOptions.search,
        allLogosData,
        popupOptions,
        popupData: themeOptions.pop_up,
        indexedEventSliderData,
        indexedPostSliderData,
        indexedNewsletterData,
        headerThemeOptions: themeOptions.header,
        securityHeaderOptions: themeOptions.security_header,
        googleMapThemeOptions: themeOptions.google_maps,
        formBulderOptions: themeOptions?.form_builder,
        seoSettingsOptions: IS_NOBLE_ELEMENTS
          ? themeOptions?.seo_settings_elements || {}
          : themeOptions?.seo_settings || {},
        indexedFormsData,
        routing,
        indexedContactData,
        PostGridCategories: postGridCategories,
        indexedAccordionData,
        indexedLinkListData,
        indexedMaterialOverviewData,
        csvFile,
        teamPosts,
        sitemapData,
        relatedMetals,
        relatedJobs,
        relatedBlogPostIds,
        IS_NOBLE_ELEMENTS,
        blogFormData,
        blogCategories,
        billettoEventsData,
        factsheets: themeOptions.factsheets,
      },
      revalidate: parseInt(process.env.REVALIDATE_AFTER || "120"),
    };
  } catch (error) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any --- FIXME: disabled temporarily on migrate to TS.
    const { dynamicRoute }: any = context.params ?? {};
    const locale = context.locale || "de";
    const defaultLocale = context.defaultLocale || "de";
    const path = `/${locale === defaultLocale ? "" : locale + "/"}${(
      dynamicRoute ?? []
    ).join("/")}`.replace("//", "/");

    console.error(`Error in getStaticProps for path "${path}":`, error);

    // Always rethrow:
    // - During build → build fails, error becomes visible
    // - At runtime (ISR) → Next.js serves cached version, no 404
    throw error;
  }
}
